import React from 'react'
import PropTypes from 'prop-types'

const SlidesAsset = ({asset}) => {
  return (
    <a
      href={asset.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      Spill av
    </a>
  )
}

SlidesAsset.propTypes = {
  asset: PropTypes.object.isRequired,
}

export default SlidesAsset
